<!-- 电子监管码弹窗组件 -->
<template>
   <el-dialog title="电子监管码录入" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false" :close-on-press-escape="true" append-to-body @open="handleDialogOpen" @close="handleDialogClose">
      <div class="regulatory-dialog">

         <div class="product-list">
            <el-table :data="regulatoryItems" border size="small" max-height="300">
               <el-table-column prop="bgmName" label="通用名称" min-width="200" />
               <el-table-column prop="batchno" label="批号" width="120" />
               <el-table-column prop="quantity" label="购买数量" width="80" align="center" />
               <el-table-column prop="scannedCount" label="已扫描" width="80" align="center">
                  <template slot-scope="scope">
                     <span :class="{ 'text-success': scope.row.scannedCount >= scope.row.quantity }">
                        {{ scope.row.scannedCount }}
                     </span>
                  </template>
               </el-table-column>
               <el-table-column label="状态" width="100" align="center">
                  <template slot-scope="scope">
                     <el-tag :type="scope.row.scannedCount >= scope.row.quantity ? 'success' : 'warning'" size="mini">
                        {{ scope.row.scannedCount >= scope.row.quantity ? '已完成' : '待扫描' }}
                     </el-tag>
                  </template>
               </el-table-column>
            </el-table>
         </div>

         <div class="scan-input">
            <el-form :model="scanForm" ref="scanForm" label-width="100px" @submit.native.prevent>
               <el-form-item label="监管码录入:">
                  <el-input v-model="scanForm.code" placeholder="请扫描或输入电子监管码(20位)" @keyup.enter.native.prevent="handleScanCode" @keydown.native="handleInputKeyDown" ref="codeInput" clearable>
                     <el-button slot="append" @click="handleScanCode" type="primary">
                        录入
                     </el-button>
                  </el-input>
               </el-form-item>
            </el-form>
         </div>

         <div class="scanned-codes" v-if="scannedCodes.length > 0">
            <div class="codes-header">
               <span>已录入监管码 ({{ scannedCodes.length }})</span>
               <el-button size="mini" type="text" @click="clearAllCodes">清空重新扫</el-button>
            </div>
            <div class="codes-list">
               <el-tag v-for="(code, index) in scannedCodes" :key="index" closable @close="removeCode(index)" class="code-tag">
                  {{ code }}
               </el-tag>
            </div>
         </div>

         <div class="progress-info">

            <div class="progress-text">
               总进度: {{ totalScanned }} / {{ totalRequired }}
               <span v-if="progressPercentage < 100" class="warning-text">
                  (还需录入 {{ totalRequired - totalScanned }} 个监管码)
               </span>
            </div>
         </div>
      </div>

      <div slot="footer" class="dialog-footer">

         <el-button type="warning" @click="handleManualSubmit"  ref="manualSubmitBtn" @keydown.native="handleButtonKeyDown">
            手动提交 ({{ scannedCodes.length }}/{{ totalRequired }})
         </el-button>
         <!-- <el-button type="primary" @click="handleConfirm" :disabled="scannedCodes.length === 0" ref="confirmSubmitBtn" @keydown.native="handleButtonKeyDown">
            确认提交
         </el-button> -->
      </div>
   </el-dialog>
</template>

<script>
export default {
   name: 'RegulatoryCodeDialog',
   props: {
      visible: {
         type: Boolean,
         default: false
      },
      cartItems: {
         type: Array,
         default: () => []
      },
      scanCodeList: {
         type: Array,
         default: () => []
      }
   },
   data() {
      return {
         dialogVisible: false,
         scanForm: {
            code: ''
         },
         scannedCodes: [],
         regulatoryItems: [],
         currentFocusIndex: 0 // 0: 输入框, 1: 手动提交按钮, 2: 确认提交按钮
      }
   },
   computed: {
      // 计算总共需要的监管码数量
      totalRequired() {
         return this.regulatoryItems.reduce((total, item) => total + item.quantity, 0)
      },
      // 计算已扫描的总数
      totalScanned() {
         return this.scannedCodes.length
      },
      // 计算进度百分比
      progressPercentage() {
         if (this.totalRequired === 0) return 0
         return Math.round((this.totalScanned / this.totalRequired) * 100)
      }
   },
   watch: {
      visible(newVal) {
         this.dialogVisible = newVal
         if (newVal) {
            this.initDialog()
         }
      },
      dialogVisible(newVal) {
         this.$emit('update:visible', newVal)
      }
   },
   methods: {
      // 初始化弹窗
      initDialog() {
         if (this.scanCodeList.length>0) {
            this.scannedCodes =this.scanCodeList
         }else{
            this.scannedCodes = []
         }
         this.scanForm.code = ''
         this.regulatoryItems = this.getRegulatoryItems()
         this.currentFocusIndex = 0 // 重置焦点到输入框

         // 延迟聚焦，确保DOM完全渲染
         setTimeout(() => {
            if (this.$refs.codeInput) {
               this.$refs.codeInput.focus()
            }
         }, 300)
      },

      // 获取需要监管码的商品
      getRegulatoryItems() {
         return this.cartItems
            .filter(item => item.bgiIsesupervise == 1)
            .map(item => ({
               ...item,
               scannedCount: 0
            }))
      },

      // 处理扫描监管码
      handleScanCode() {
         const code = this.scanForm.code.trim()
         if (!code) {
            this.$message.warning('请输入监管码')
            return
         }

         // 校验监管码长度必须为20位
         if (code.length !== 20) {
            this.$message.warning('监管码必须为20位，请重新输入')
            this.scanForm.code = ''
            this.$refs.codeInput.focus()
            return
         }

         // 检查是否重复
         if (this.scannedCodes.includes(code)) {
            this.$message.warning('该监管码已录入，请勿重复扫描')
            this.scanForm.code = ''
            this.$refs.codeInput.focus()
            return
         }

         // 添加到已扫描列表
         this.scannedCodes.push(code)
         this.updateScannedCount()

         // 清空输入框并聚焦
         this.scanForm.code = ''
         this.$refs.codeInput.focus()

         const message = this.totalScanned >= this.totalRequired
            ? `监管码录入成功 (${this.totalScanned}/${this.totalRequired}) - 已达到要求数量`
            : `监管码录入成功 (${this.totalScanned}/${this.totalRequired})`
         this.$message.success(message)

         // 检查是否扫够数量，如果扫够则自动提交
         if (this.totalScanned == this.totalRequired) {
            // 延迟一点时间让用户看到成功消息，然后自动提交
            setTimeout(() => {
               this.$message.success('监管码已全部录入完成，正在自动提交...')
               this.handleConfirm()
            }, 1000)
         }
      },

      // 输入框键盘导航处理
      handleInputKeyDown(event) {
         if (event.key === 'ArrowDown') {
            event.preventDefault()
            this.currentFocusIndex = 1
            this.focusElement()
         } else if (event.key === 'ArrowUp') {
            event.preventDefault()
            this.currentFocusIndex = 2
            this.focusElement()
         }
      },

      // 按钮键盘导航处理
      handleButtonKeyDown(event) {
         if (event.key === 'ArrowDown') {
            event.preventDefault()
            if (this.currentFocusIndex === 1) {
               this.currentFocusIndex = 2
            } else if (this.currentFocusIndex === 2) {
               this.currentFocusIndex = 0
            }
            this.focusElement()
         } else if (event.key === 'ArrowUp') {
            event.preventDefault()
            if (this.currentFocusIndex === 1) {
               this.currentFocusIndex = 0
            } else if (this.currentFocusIndex === 2) {
               this.currentFocusIndex = 1
            }
            this.focusElement()
         }
      },

      // 根据当前焦点索引聚焦到对应元素
      focusElement() {
         this.$nextTick(() => {
            if (this.currentFocusIndex === 0) {
               // 聚焦到输入框
               if (this.$refs.codeInput) {
                  this.$refs.codeInput.focus()
               }
            } else if (this.currentFocusIndex === 1) {
               // 聚焦到手动提交按钮
               if (this.$refs.manualSubmitBtn && !this.$refs.manualSubmitBtn.disabled) {
                  this.$refs.manualSubmitBtn.$el.focus()
               } else {
                  // 如果按钮被禁用，跳到下一个
                  this.currentFocusIndex = 2
                  this.focusElement()
               }
            } else if (this.currentFocusIndex === 2) {
               // 聚焦到确认提交按钮
               if (this.$refs.confirmSubmitBtn && !this.$refs.confirmSubmitBtn.disabled) {
                  this.$refs.confirmSubmitBtn.$el.focus()
               } else {
                  // 如果按钮被禁用，跳到输入框
                  this.currentFocusIndex = 0
                  this.focusElement()
               }
            }
         })
      },

      // 更新各商品的扫描数量
      updateScannedCount() {
         let remainingCodes = this.scannedCodes.length

         this.regulatoryItems.forEach(item => {
            if (remainingCodes >= item.quantity) {
               item.scannedCount = item.quantity
               remainingCodes -= item.quantity
            } else {
               item.scannedCount = remainingCodes
               remainingCodes = 0
            }
         })
      },

      // 移除监管码
      removeCode(index) {
         this.scannedCodes.splice(index, 1)
         this.updateScannedCount()
      },

      // 清空所有监管码
      clearAllCodes() {
         this.$confirm('确定要清空所有已录入的监管码吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.scannedCodes = []
            this.updateScannedCount()
            this.$message.success('已清空所有监管码')
            this.$refs.codeInput.focus()
         }).catch(() => { })
      },


      // 手动提交
      handleManualSubmit() {
         if (this.totalScanned < this.totalRequired) {
            const shortage = this.totalRequired - this.totalScanned
            this.$confirm(
               `还有 ${shortage} 个监管码未录入，是否确认提交？`,
               '确认提交',
               {
                  confirmButtonText: '确认提交',
                  type: 'warning'
               }
            ).then(() => {
               this.handleConfirm()
            }).catch(() => {
               this.$refs.codeInput.focus()
            })
         } else {
            this.handleConfirm()
         }
      },

      // 确认提交
      async handleConfirm() {
       

         try {
            // 构建提交数据
            const submitData = {
               regulatoryCodes: this.scannedCodes,
               items: this.regulatoryItems.map(item => ({
                  bgiId: item.bgiId,
                  bgiCode: item.bgiCode,
                  bgiName: item.bgiName,
                  quantity: item.quantity,
                  scannedCount: item.scannedCount
               })),
               totalRequired: this.totalRequired,
               totalScanned: this.totalScanned,
               isComplete: this.totalScanned >= this.totalRequired,

            }

            // 触发确认事件
            this.$emit('confirm', submitData)
            this.dialogVisible = false

         } catch (error) {
            console.error('提交监管码失败:', error)
            this.$message.error('提交失败，请重试')
         }
      },

      // 弹窗打开事件
      handleDialogOpen() {
         // 弹窗打开后自动聚焦到输入框
         this.$nextTick(() => {
            if (this.$refs.codeInput) {
               this.$refs.codeInput.focus()
            }
         })

         // 添加键盘事件监听
         document.addEventListener('keydown', this.handleKeyDown)
      },

      // 键盘事件处理
      handleKeyDown(event) {
         // 只在弹窗显示时处理ESC键
         if (this.dialogVisible && event.key === 'Escape') {
            event.preventDefault()
            event.stopPropagation()
            if (this.scannedCodes.length > 0) {
               this.$confirm(
                  '是否关闭弹窗？',
                  '提示',
                  {
                     confirmButtonText: '确定关闭',
                     showCancelButton: false,
                     type: 'warning'
                  }
               ).then(() => {
                  // 用户确认关闭
                  this.scannedCodes = []
                  this.dialogVisible = false
                  this.$emit('close')
               }).catch(() => {
                  // 用户取消关闭，重新打开弹窗
                  this.dialogVisible = true
                  this.$nextTick(() => {
                     if (this.$refs.codeInput) {
                        this.$refs.codeInput.focus()
                     }
                  })
               })
            } else {
               // 没有录入监管码时直接关闭
               this.dialogVisible = false
               this.$emit('close')
            }
         }
      },

      // 弹窗关闭事件（ESC或点击X按钮）
      handleDialogClose() {
         // 没有录入监管码时直接关闭
         this.dialogVisible = false
         this.$emit('close')

         // 移除键盘事件监听
         document.removeEventListener('keydown', this.handleKeyDown)
      }
   },

   // 组件销毁时清理事件监听
   beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeyDown)
   }
}
</script>

<style scoped>
.regulatory-dialog {
   padding: 10px 0;
}

.header-info {
   margin-bottom: 20px;
}

.product-list {
   margin-bottom: 20px;
}

.scan-input {
   margin-bottom: 20px;
}

.scanned-codes {
   margin-bottom: 20px;
   border: 1px solid #e4e7ed;
   border-radius: 4px;
   padding: 15px;
   background-color: #fafafa;
}

.codes-header {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 10px;
   font-weight: bold;
}

.codes-list {
   max-height: 120px;
   overflow-y: auto;
}

.code-tag {
   margin: 2px 5px 2px 0;
   font-family: monospace;
}

.progress-info {
   margin-bottom: 10px;
}

.progress-text {
   margin-top: 10px;
   text-align: center;
   font-size: 14px;
}

.warning-text {
   color: #e6a23c;
   font-weight: bold;
}

.text-success {
   color: #67c23a;
   font-weight: bold;
}

.dialog-footer {
   text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
   .regulatory-dialog {
      padding: 5px 0;
   }

   .codes-list {
      max-height: 80px;
   }
}
</style>
